import React, { useEffect, useState } from "react";
import { login, loginGoogle, loginFacebook, register, loginUnique, loginPrize, } from "../../function/auth";
import { Spin } from "antd";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "@mui/material";

import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
// import { Button } from '@mui/material';

import logo from "./logo/logo.png";
import { BsFacebook } from 'react-icons/bs';
import { FcGoogle } from "react-icons/fc";
import { SiLine } from "react-icons/si";

import axios from 'axios';

import { auth, googleAuthProvider } from "../../firebase";

const LoginByLine = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleLoginByLine = () => {
        const clientId = process.env.REACT_APP_LINE_CLIENT_ID;
        const redirectUri = process.env.REACT_APP_LINE_REDIRECT_URI;
        console.log("LINE CLIENT_ID:", clientId);
        console.log("LINE REDIRECT_URI:", redirectUri);
        console.log("Line Client ID:", clientId);
        const state = "randomState123";
        const scope = "profile openid email";

        const lineLoginUrl = `https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&state=${state}&scope=${scope}`;

        window.location.href = lineLoginUrl;
    };

    return (
        <div className="login p-5 ">
            <div className="row justify-content-center mt-2">
                <div
                    className="col-md-6"
                    style={{
                        boxShadow: "0 3px 10px rgba(0, 0, 0, 0.2)",
                        padding: "2rem",
                        borderRadius: "8px",
                        background: "#ffff"
                    }}
                >
                    <div className="text-center mb-4">
                        <img
                            src={logo}
                            alt="Logo"
                            className="img-fluid"
                            style={{ maxWidth: "200px" }}
                        />
                        <h4>เข้าสู่ระบบ</h4>
                    </div>


                    <div className="text-center">
                        <Button
                            onClick={handleLoginByLine}
                            variant="contained"
                            startIcon={<SiLine size={10} />}
                            style={{
                                backgroundColor: "#06C755",
                                color: "#fff",
                                textTransform: "none",
                                fontWeight: "bold",
                                padding: "10px 20px",
                                borderRadius: "5px",
                                marginTop: "20px",
                            }}
                        >
                            Sign in with LINE
                        </Button>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default LoginByLine
